import { memo } from "react";
import type { CompositionKey } from "../../CompositionsLight";
import PlayerContent from "./components/PlayerContent";
import { PlayerProps } from "./types";

const Player = <TComp extends CompositionKey>(
	props: PlayerProps<TComp> & {
		composition: TComp;
	},
) => {
	return <PlayerContent {...props} />;
};
export default memo(Player) as any;
